<template>
	<div>
		<DashboardHeaderVue :title="$route.name" />
	</div>
</template>
<script>
import DashboardHeaderVue from '../HeaderFooterComponents/DashboardHeader.vue';

export default {
	name: 'messages',
	components: {
		DashboardHeaderVue,
	},
	data() {
		return {};
	},
};
</script>
